import '@holmescorp/quiz-widgets';
import '@holmescorp/cut-scores';
import '@holmescorp/resource-parser';
import '@holmescorp/topic-progress';

import { Glossary } from 'glossary';
import { registry } from 'lcc-state';
import { LearningActivity } from 'learning-activity';
import { RiseActivation } from '@holmescorp/rise-activation';
import {
	LPGroup,
	LPIcon,
	LPPageGroup,
	LPText,
	LPTool,
	LPToolCard,
	LPToolbar,
	LPTopicRoot,
	LPView,
	LPWidget
} from 'lp-widgets';
import { MCSelector } from 'quiz-widgets/questions/mc-selector';

import { PosttestCard, PracticeCard, GeneralCard, PretestReviewCard } from '@holmescorp/card';
import { Carousel } from '@holmescorp/carousel';
import { CertificateCard } from '@holmescorp/certificate';
import { LandingPage } from '@holmescorp/landing-page';
import { RCSCard } from '@holmescorp/lcc-rcs';
import { ProgressView, FinalTestView, GlossaryView, Breadcrumbs } from '@holmescorp/mc-widgets';

export function register_lp_widgets(): void {
	registry.define('LPView', LPView);
	registry.define('PageGroup', LPPageGroup);
	registry.define('Group', LPGroup);
	registry.define('TopicRoot', LPTopicRoot);
	registry.define('Text', LPText);
	registry.define('Icon', LPIcon);
	registry.define('Toolbar', LPToolbar);
	registry.define('Tool', LPTool);
	registry.define('ToolCard', LPToolCard);
	registry.define('Carousel', Carousel);
	registry.define('Widget', LPWidget);
	// widgets loaded via LPWidget
	// registry.define('Breadcrumbs', Breadcrumbs);
	// registry.define('Evaluation', Evaluation);
	// registry.define('ExamCountdown', ExamCountdown);
	registry.define('LearningActivity', LearningActivity);
	registry.define('RiseActivation', RiseActivation);
	registry.define('Glossary', Glossary);
	registry.define('LandingPage', LandingPage);
	registry.define('MicroBreadcrumbs', Breadcrumbs);
	registry.define('ProgressView', ProgressView);
	registry.define('FinalTestView', FinalTestView);
	registry.define('GlossaryView', GlossaryView);

	// widgets for additional resources carousel
	registry.define('CertificateCard', CertificateCard);
	registry.define('GeneralCard', GeneralCard);
	registry.define('PracticeCard', PracticeCard);
	registry.define('PretestReviewCard', PretestReviewCard);
	registry.define('PosttestCard', PosttestCard);
	registry.define('RCSCard', RCSCard);

	registry.define('ResourceCenter', async (): Promise<any> => {
		const { ResourceCenter } = await import('lcc-rcs');
		return ResourceCenter;
	});
	registry.define('Search', async (): Promise<any> => {
		const { Search } = await import('search-widget');
		return Search;
	});
	registry.define('Video', async (): Promise<any> => {
		const { Video } = await import('video');
		return Video;
	});
	registry.define('Certificate', async (): Promise<any> => {
		const { Certificate } = await import('certificate');
		return Certificate;
	});
	registry.define('AskTheInstructor', async (): Promise<any> => {
		const { AskTheInstructor } = await import('ask-the-instructor');
		return AskTheInstructor;
	});
	registry.define('Announcements', async (): Promise<any> => {
		const { Announcements } = await import('announcements');
		return Announcements;
	});
	registry.define('ClassRoster', async (): Promise<any> => {
		const { ClassRoster } = await import('class-roster');
		return ClassRoster;
	});
	registry.define('Editor', async (): Promise<any> => {
		const { Editor } = await import('editor-widget');
		return Editor;
	});
	// setup casestudy to use multiple choice instead
	registry.define('MicroQuiz', MCSelector);

	// other widgets
	// registry.define('TopRecommended', TopRecommended);
	// registry.define('FirstRecommended', FirstRecommended);
	// registry.define('StudyPlan', StudyPlan);
}
